var version = {
    "name":      "dativery",
    "buildDateCode": "20251205-120739",
    "buildDate": "Fri Dec 05 2025 12:07:39 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251205-120739",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;